import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store/store';
import { pointsApi } from '@/lib/store/api-helpers/pointsApi';
import { retryPromotionsApi } from '@/lib/store/api-helpers/retryPromotionsApi';

interface CriticalDataState {
  points: number | null;
  retryPromotions: boolean | null;
  lastUpdated: string | null;
}

const initialState: CriticalDataState = {
  points: null,
  retryPromotions: null,
  lastUpdated: null,
};


export const criticalDataSlice = createSlice({
  name: 'criticalData',
  initialState,
  reducers: {
    resetState: (state) => {
      Object.assign(state, initialState);
    },
    setPoints: (state, action: PayloadAction<number>) => {
      state.points = action.payload;
      state.lastUpdated = new Date().toISOString();
    },
    setRetryPromotions: (state, action: PayloadAction<boolean>) => {
      state.retryPromotions = action.payload;
      state.lastUpdated = new Date().toISOString();
    }
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(pointsApi.endpoints.getPoints.matchFulfilled, (state, action) => {
        state.points = action.payload;
        state.lastUpdated = new Date().toISOString();
      })
      .addMatcher(retryPromotionsApi.endpoints.getRetryPromotions.matchFulfilled, (state, action) => {
        state.retryPromotions = action.payload;
        state.lastUpdated = new Date().toISOString();
      });
  }
});

// Selektoren
export const selectPoints = (state: RootState) => state.criticalData.points;
export const selectRetryPromotions = (state: RootState) => state.criticalData.retryPromotions;
export const selectPointsLastUpdated = (state: RootState) => state.criticalData.lastUpdated;

export const { resetState, setPoints, setRetryPromotions } = criticalDataSlice.actions;

export default criticalDataSlice.reducer; 